// generated from 2_657 samples

import { z } from "zod";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { grapesJsDataSchema } from "../grapesJs/grapesJsDataSchema";
import { surveyDefinitionGetSchema } from "./surveyDefinitionGetSchema";
import { orBehaviorTriggerGetSchema } from "../trigger/orBehaviorTriggerGetSchema";
import { triggerGetSchema } from "../trigger/triggerGetSchema";

export const bannerCompositionModeSchema = z.enum(["dnd", "html"]);

// Property types from shared_constants.json SDK_MESSAGE_PROPERTIES.TYPES,
// validated by Braze::SdkMessageProperties::Validation.
export const bannerMessagePropertiesGetSchema = z.record(
  z.string(),
  z.discriminatedUnion("type", [
    z.object({
      type: z.literal("string"),
      value: z.string(),
    }),
    z.object({
      type: z.literal("boolean"),
      value: z.boolean(),
    }),
    z.object({
      type: z.literal("number"),
      value: z.number(),
    }),
    z.object({
      type: z.literal("image"),
      value: z.string(),
    }),
    z.object({
      type: z.literal("datetime"),
      value: z.string(),
    }),
    z.object({
      type: z.literal("jsonobject"),
      value: z.record(z.string(), z.any()),
    }),
  ])
);

export const bannerExpirationScheduleSchema = z
  .object({
    availability_in_seconds: z.number().optional(),
    availability_expiration_in_user_local_time: z.boolean().optional(),
    availability_expiration_time: z.string().optional(),
    personalized_expiration_duration_variable: z.string().optional(),
    personalized_expiration_duration_variable_type: z.string().optional(),
    personalized_expiration_duration_variable_unit: z.string().optional(),
  })
  .nullable()
  .optional();

export const bannerMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("banner"),
  // undefined: 1_248 (46.97%), defined 1_409 (53.03%)
  // server always returns this key; null when not set
  analytics_id: z.string().length(84).nullable().optional(),
  // Canvas-only: controls when the banner expires after display
  expiration_schedule: bannerExpirationScheduleSchema,
  // Canvas-only: placement IDs that determine where the banner appears
  banner_placement_ids: z.array(z.string()).optional(),
  // undefined: 1_248 (46.97%), defined 1_409 (53.03%)
  // null: 187 (13.27%)
  // server always returns this key; null when no DnD data
  grapes_js_data: grapesJsDataSchema.nullable(),
  composition_mode: bannerCompositionModeSchema.optional(),
  // undefined: 1_248 (46.97%), defined 1_409 (53.03%)
  // null: 168 (11.92%)
  html: z.string().nullable().optional(),
  // null: 1 (0.04%)
  link_template_ids: z.array(z.string()).nullable().optional(),
  optimal_send_percentage: z.int().min(0).max(100).nullable(),
  // undefined: 1_248 (46.97%), defined 1_409 (53.03%)
  // null: 1_406 (99.79%)
  properties: z.union([z.string(), bannerMessagePropertiesGetSchema]).nullable().optional(),
  survey_definition: surveyDefinitionGetSchema.nullable().optional(),
  // Campaign-only: controls when the banner is removed from users who match the trigger event
  removal_schedule: z
    .object({
      removal_event: z.union([orBehaviorTriggerGetSchema, triggerGetSchema]),
    })
    .nullable()
    .optional(),
});
